export default __webpack_public_path__ + "static/desk3500-7deb01a189d4574dc851049fb1d93c2e.png";